import React from 'react';
import RadioDualComponent from 'shared/components/RadioDualComponent';

const StencilAlignment = (props) => {
  const name = 'alignment';

  const {
    label,
    parameters,
    onChangeParameter,
    tooltip,
    className,
    groupName,
    required,
    errorMessage,
  } = props;

  const onChange = (e) => onChangeParameter(name, e.target.value);

  return (
    <RadioDualComponent
      name={name}
      label={label}
      tooltip={tooltip}
      onChange={onChange}
      parameters={parameters}
      className={className}
      groupName={groupName}
      required={required}
      labelA="Offset"
      valueA="Offset"
      labelB="Center"
      valueB="Center"
      labelClassName="d-block"
      errorMessage={errorMessage} />
  );
};

StencilAlignment.defaultProps = {
  label: Spree.translations.parameters.alignment,
  tooltip: Spree.helpForParameters.alignment,
  className: 'class-3-inspection',
};

export default StencilAlignment;
